import { FC, useState } from 'react';
import { ItemTabs } from '../ItemTabs';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
// import EFVideo from '@/components/UI/EFVideo';
import NextImage from '@/components/NextImage';

export const ZHComp: FC = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const [activeIdx, setActiveIdx] = useState(0);
    const textList = [
        {
            tabs: t('sec17_tab1'),
            title: t('sec17_title0'),
            desc: t('sec17_desc0'),
        },
        {
            tabs: t('sec17_tab2'),
            title: t('sec17_title1'),
            desc: t('sec17_desc1'),
        },
        {
            tabs: t('sec17_tab3'),
            title: t('sec17_title2'),
            desc: t('sec17_desc2'),
        },
        {
            tabs: t('sec17_tab4'),
            title: t('sec17_title3'),
            desc: t('sec17_desc3'),
        },
    ];

    return (
        <div className={`${css.ZHComp} GtmModuleData-section`} data-section-id={css.ZHComp} data-section-title={t('sec17_title')}>
            <div className="subtitle">{t('sec17_subtitle')}</div>
            <div className="title">{t('sec17_title')}</div>
            <div className="video-box-wrapper">
                <div className="video-box" style={{ display: activeIdx === 0 ? 'block' : 'none' }}>
                    {/* <EFVideo
                        className="video fullImgs"
                        sources={['/video/delta2max/teaser/pc/eu/17-1.webm', '/video/delta2max/teaser/pc/eu/17-1.mp4']}
                        width="100%"
                        height="100%"
                        aria-label={t('sec17_title')}
                    /> */}
                    {locale !== 'cn' && (
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-1.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/zh-1.jpg')}
                            alt={t('sec17_title')}
                            aria-label={t('sec17_title')}
                        />
                    )}
                    {locale === 'cn' && (
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-1_cn.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/zh-1_cn.jpg')}
                            alt={t('sec17_title')}
                            aria-label={t('sec17_title')}
                        />
                    )}
                </div>
                <div className="video-box" style={{ display: activeIdx === 1 ? 'block' : 'none' }}>
                    {/* <EFVideo
                        className="video fullImgs"
                        sources={['/video/delta2max/teaser/pc/eu/17-2.webm', '/video/delta2max/teaser/pc/eu/17-2.mp4']}
                        width="100%"
                        height="100%"
                        aria-label={t('sec17_title')}
                    /> */}
                    {locale !== 'cn' && (
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-2.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/zh-2.jpg')}
                            alt={t('sec17_title')}
                            aria-label={t('sec17_title')}
                        />
                    )}
                    {locale === 'cn' && (
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-2_cn.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/zh-2_cn.jpg')}
                            alt={t('sec17_title')}
                            aria-label={t('sec17_title')}
                        />
                    )}
                </div>
                <div className="video-box" style={{ display: activeIdx === 2 ? 'block' : 'none' }}>
                    {/* <EFVideo
                        className="video fullImgs"
                        sources={['/video/delta2max/teaser/pc/eu/17-3.webm', '/video/delta2max/teaser/pc/eu/17-3.mp4']}
                        width="100%"
                        height="100%"
                        aria-label={t('sec17_title')}
                    /> */}
                    {locale !== 'cn' && (
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-3.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/zh-3.jpg')}
                            alt={t('sec17_title')}
                            aria-label={t('sec17_title')}
                        />
                    )}
                    {locale === 'cn' && (
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-3_cn.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/zh-3_cn.jpg')}
                            alt={t('sec17_title')}
                            aria-label={t('sec17_title')}
                        />
                    )}
                </div>
                <div className="video-box" style={{ display: activeIdx === 3 ? 'block' : 'none' }}>
                    {/* <EFVideo
                        className="video fullImgs"
                        sources={['/video/delta2max/teaser/pc/eu/17-4.webm', '/video/delta2max/teaser/pc/eu/17-4.mp4']}
                        width="100%"
                        height="100%"
                        aria-label={t('sec17_title')}
                    /> */}
                    {locale !== 'cn' && (
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-4.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/zh-4.jpg')}
                            alt={t('sec17_title')}
                            aria-label={t('sec17_title')}
                        />
                    )}
                    {locale === 'cn' && (
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-4_cn.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/zh-4_cn.jpg')}
                            alt={t('sec17_title')}
                            aria-label={t('sec17_title')}
                        />
                    )}
                </div>
            </div>
            <ItemTabs title={t('sec17_title')} list={textList.map((item) => item.tabs)} onTabClick={setActiveIdx} />
            <div className="save-title">{textList[activeIdx].title}</div>
            <div className="save-desc">{textList[activeIdx].desc}</div>
        </div>
    );
};
